module.exports = __webpack_public_path__ + "static/media/29FUNOV12.b6c7d478.jpg";